/**
 * Enum of all CMS collections that can be access-controlled.
 * Shared between the API and the Internal CMS.
 */
export enum ECmsCollection {
  TTE_CAMPAIGNS = "tte-campaigns",
  HTE_CAMPAIGNS = "hte-campaigns",
  CAMPAIGN_PARTNERS = "campaign-partners",
  QUESTS = "quests",
  CASHBACK = "cashback",
  BLACKLIST = "blacklist",
  WHITELIST = "whitelist",
  MEDIA = "media",
  AUTOMATIC_STREAK_CONFIG = "automatic-streak-config",
  ONCHAIN_CONFIG = "onchain-config",
  FEATURE_FLAGS = "feature-flags",
  HUB_BANNERS = "hub-banners",
  HUB_UPDATES = "hub-updates",
  SPINNING_WHEEL_CONFIG = "spinning-wheel-config",
  ONBOARDING_STEPS = "onboarding-steps",
  TRADE_TUTORIAL_STEPS = "trade-tutorial-steps",
  HUB_USERS = "hub-users",
  PERMISSIONS = "permissions",
  CEDE_FLOW_TRADE_AND_EARN_COMPETITIONS = "cede-flow-trade-and-earn-competitions",
  /** Cede Arena entries — paid 1v1 opt-ins waiting to be matched into a campaign. */
  ARENA_ENTRIES = "arena-entries",
  /** Cede Arena competition blueprints — recurring competition templates that generate campaigns. */
  CEDE_ARENA_COMPETITION_BLUEPRINTS = "cede-arena-competition-blueprints",
  /** Cede Arena whitelisted users — hub users who opt into Arena with the entry fee waived. */
  ARENA_WHITELISTED_USERS = "arena-whitelisted-users",
  /** Cede Arena announcements — modal banners shown to users based on UTM targeting. */
  ARENA_ANNOUNCEMENTS = "arena-announcements",
  /** Cede Arena matchmaking — per-tier (free/paid) duel settings: duration, entry fee, pairs, min volume, initial deposit. */
  ARENA_MATCHMAKING = "arena-matchmaking",
  ARENA_REENGAGEMENT = "arena-reengagement",
  /** Cede Arena tickets — the available free-entry ticket denominations and the new-user starter pack. */
  ARENA_TICKETS = "arena-tickets",
  /** Cede Arena partner ticket links — per-partner `/i/<slug>` signup links that grant a custom ticket pack. */
  ARENA_TICKET_LINKS = "arena-ticket-links",
  /** Cede Arena deposit rails — the Unifold / Crossmint switches and the countries routed to Unifold. */
  ARENA_DEPOSITS = "arena-deposits",
  /** Cede Arena ops dashboard — read-only cohort/money/ticket/matchmaking panels over live Arena state. */
  ARENA_OPS = "arena-ops",
  /** Cede Arena support chat — the Solo CMS inbox for reading and replying to user support conversations. */
  ARENA_SUPPORT_CHATS = "arena-support-chats",
  /** Cede Arena affiliate applications — KOL applications from the public affiliate landing page, reviewed here. */
  ARENA_AFFILIATE_APPLICATIONS = "arena-affiliate-applications",
  /** Big Arena Competition: whitelist registrations from `/100k` and the KOL priority codes that auto-accept them. */
  BIG_ARENA_COMPETITION = "big-arena-competition",
  /** Cede Arena referrals — the referral programme config and the referrer → referee roster. */
  ARENA_REFERRALS = "arena-referrals",
  /** Cede Arena clans: the clans, their members and chiefs, clan tournaments, and the rejoin cooldown. */
  ARENA_CLANS = "arena-clans",
  /** Geo restrictions — hide a campaign, or every campaign on an exchange, from given countries. */
  GEO_RESTRICTIONS = "geo-restrictions",
  /** A/B experiments — variant definitions, weights and enrolment windows. */
  EXPERIMENTS = "experiments",
}
